export const DownArrowSvg: React.FC<{
  height?: number;
  width?: number;
  style?: React.CSSProperties;
}> = ({ height = 400, width = 15, style }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox={`0 0 15 ${height}`}
    fill='none'
    style={style}
  >
    <path
      d={`M6.7299 ${height - 0.543}C7.12043 ${height - 0.152} 7.75359 ${height - 0.152} 8.14412 ${height - 0.543}L14.5081 ${height - 6.907}C14.8986 ${height - 7.297} 14.8986 ${height - 7.93} 14.5081 ${height - 8.321}C14.1176 ${height - 8.711} 13.4844 ${height - 8.711} 13.0939 ${height - 8.321}L7.43701 ${height - 2.664}L1.78016 ${height - 8.321}C1.38963 ${height - 8.711} 0.756468 ${height - 8.711} 0.365944 ${height - 8.321}C-0.0245805 ${height - 7.93} -0.0245805 ${height - 7.297} 0.365944 ${height - 6.907}L6.7299 ${height - 0.543}ZM7.43701 0.77832H6.43701V${height - 1.25}H7.43701H8.43701V0.77832H7.43701Z`}
      fill='black'
    />
  </svg>
);
